"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * SDK cache with expiration time support.
 */
var SDKCache = /*#__PURE__*/function () {
  /**
   * Cache constructor
   *
   * @param config - the sdk configuration object
   */
  function SDKCache(config) {
    (0, _classCallCheck2["default"])(this, SDKCache);
    this.cacheEntity = new Map();
    this.max = config.cacheSize; // The maximum size of the cache
    this.maxAge = config.cacheExpiration; // Maximum age in ms
  }

  /**
   * Get a value for key.
   *
   * @param key - The target cache key
   *
   * @returns the cached value
   */
  return (0, _createClass2["default"])(SDKCache, [{
    key: "get",
    value: function get(key) {
      var entity = this.cacheEntity.get(key);
      if (!entity) return undefined;
      var value = entity.value,
        time = entity.time,
        age = entity.age;
      if (new Date().getTime() - time > age) {
        this.del(key);
        return undefined;
      }
      return value;
    }

    /**
     * Set a value to cache.
     *
     * @param key - the cache key
     * @param value - the cached value
     * @param maxAge - a specific expire time to override the default
     *
     * @returns true if the value is set, otherwise false
     */
  }, {
    key: "set",
    value: function set(key, value, maxAge) {
      var _this = this;
      if (maxAge && (typeof maxAge !== 'number' || maxAge < 0)) throw 'maxAge is not a valid number!';

      // Iterate the cache and auto clear expired data
      this.keys().map(function (key) {
        return _this.get(key);
      });

      // Ignore if the cache size exceed max number
      if (!this.cacheEntity.has(key) && this.cacheEntity.size > this.max) {
        return false;
      }

      // Save value to cached entity
      var age = maxAge !== undefined && maxAge !== null ? maxAge : this.maxAge;
      this.cacheEntity.set(key, {
        value: value,
        time: new Date().getTime(),
        age: age
      });
      return true;
    }

    /**
     * Delete a value from cache
     */
  }, {
    key: "del",
    value: function del(key) {
      this.cacheEntity["delete"](key);
    }

    /**
     * Cleanup the entire cache
     */
  }, {
    key: "clear",
    value: function clear() {
      this.cacheEntity.clear();
    }

    /**
     * Return an array of the keys in the cache
     *
     * @returns an array of the keys in the cache
     */
  }, {
    key: "keys",
    value: function keys() {
      return Array.from(this.cacheEntity.keys());
    }

    /**
     * Validate if the cache contains specific key
     *
     * @returns true if the cache contains the key, otherwise false
     */
  }, {
    key: "has",
    value: function has(key) {
      return this.cacheEntity.has(key);
    }
  }]);
}();
var _default = exports["default"] = SDKCache;